<template>
  <div class="active-box">
    <img src="~@/assets/img/vipDay/vip-day.jpg" alt="灵云听语会员日">
  </div>
</template>

<script>
import checkLink from '@/mixins/checkLink'
export default {
  name: 'VipDayActivity',
  mixins: [checkLink]
}
</script>

<style scoped lang="scss">
.active-box {
  min-height: 100vh;
  background-color: #fde428;
  img {
    display: block;
    width: 100vw;
  }
}
</style>
